import { useSecureFederatedQuery } from '@at/sauron-platform-graphql'
import { useHistory } from 'react-router'
import { userEmailVerificationQuery } from './query/user.fed.query'
import { ApolloQueryResult } from '@apollo/client'
import { UserEmailVerificationQuery } from './query/__generated__/user.fed.query'
const fireVerificationEmail = async (email: string, path: string) => {
    const verificationUri = '/auth/login/verification-email'

    return await fetch(verificationUri, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
            username: email,
            afterSignInUrl: path,
        }),
    })
        .then((response) => response.ok)
        .catch(() => false)
}

interface UseEmailVerification {
    emailVerified: boolean
    sendVerificationEmail: () => Promise<boolean>
    loading: boolean
    userEmailVerificationRefetch: () => Promise<ApolloQueryResult<UserEmailVerificationQuery>>
}

export const useEmailVerification = (): UseEmailVerification => {
    const {
        location: { pathname },
    } = useHistory()

    const {
        data,
        loading,
        refetch: userEmailVerificationRefetch,
    } = useSecureFederatedQuery<UserEmailVerificationQuery>(userEmailVerificationQuery, {
        fetchPolicy: 'no-cache',
    })

    if (!data?.user) {
        return { loading, emailVerified: false, sendVerificationEmail: async () => false, userEmailVerificationRefetch }
    }
    const { email, emailVerified } = data?.user

    const sendVerificationEmail = async () => {
        return fireVerificationEmail(email, pathname)
    }

    return { emailVerified, sendVerificationEmail, loading, userEmailVerificationRefetch }
}
